import { useCallback } from 'react';

import applyImageFileToCanvas from '../utils/applyImageFileToCanvas';
import useStore from './useStore';

const usePasteImageFromClipboard = () => {
  const store = useStore();

  const pasteImageFromClipboard = useCallback(async () => {
    if (!navigator.clipboard?.read) {
      return false;
    }

    let clipboardItems;
    try {
      clipboardItems = await navigator.clipboard.read();
    } catch {
      return false;
    }

    const imageItem = clipboardItems.find((item) =>
      item.types.some((type) => type.startsWith('image/')),
    );
    if (!imageItem) {
      return false;
    }

    const imageType = imageItem.types.find((type) => type.startsWith('image/'));
    const blob = await imageItem.getType(imageType);
    const file = new File([blob], 'clipboard-image', { type: imageType });

    return applyImageFileToCanvas({
      file,
      dispatch: store.dispatch,
      annotations: store.annotations,
      selectionsIds: store.selectionsIds,
      shownImageDimensions: store.shownImageDimensions,
      adjustments: store.adjustments,
    });
  }, [store]);

  return { pasteImageFromClipboard };
};

export default usePasteImageFromClipboard;
